// src/components/landing/FeaturesSection.tsx
import Link from "next/link";

export function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#001489' }}>Get Found. Get Booked. Get Paid.</h2>
          <p className="text-lg max-w-2xl mx-auto mb-6" style={{ color: '#555555' }}>
            Your profile. Your reputation. Your growth.
          </p>
          <p className="text-lg max-w-2xl mx-auto mb-6" style={{ color: '#001489' }}>
            Zamzi Connect: We handle the Search. You handle the Success.
          </p>
        </div>

                <div className="mb-12">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto">
            <h3 className="text-xl font-bold mb-4" style={{ color: '#001489' }}>For Service Pros</h3>
            <ul className="list-disc pl-6 text-base mb-4" style={{ color: '#555555' }}>
              <li>Paid users get discoverability-focused profiles for stronger search visibility.</li>
              <li>Present your services, location, and trust signals with more clarity.</li>
              <li>Instant WhatsApp leads and Smart Enquiries for direct client contact.</li>
              <li>Our AI analyzes your profile and gives you the exact suggestions needed to stand out.</li>
              <li>Show customers why you are worth choosing and manage bookings in one place.</li>
            </ul>
            <Link href="/for-business-owners" className="inline-block bg-[#FFB81C] text-white font-bold py-2 px-6 rounded mt-4">For Businesses</Link>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-lg font-bold" style={{ color: '#001489' }}>
            Zamzi Connect: Be Found. Be Trusted. Be Chosen.
          </p>
        </div>
      </div>
    </section>
  );
}
